import { uniqueId } from 'lodash';

export const getId = () => Date.now().toString() + uniqueId();
